module.exports = __webpack_public_path__ + "static/media/rom21.81f290be.jpg";